import { IconButton } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Slide from "@mui/material/Slide";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import useKothar from "context/useKothar";
import * as React from "react";
import { IoCloseCircleOutline } from "react-icons/io5";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function StudentModal({ open, handleCancel, data, uni }) {
  const [{ courseList }, { refetchCourseList }] = useKothar();

  React.useEffect(() => {
    if (open && !courseList?.length) refetchCourseList();
  }, [open, courseList?.length, refetchCourseList]);

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCancel}
        maxWidth={"lg"}
        fullWidth={"lg"}
      >
        <DialogTitle className="font-bold uppercase">Students List of {uni?.name}</DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleCancel}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <IoCloseCircleOutline />
        </IconButton>
        <hr />
        <DialogContent>
          <DialogContentText className="text-lg py-3">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }} align="right">
                      Contact
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }} align="right">
                      Course
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }} align="right">
                      Fee
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }} align="right">
                      Visa Expiry
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.number}</TableCell>
                      <TableCell align="right">
                        {courseList?.find((c) => c?.courseId === row?.course)?.courseName || "-"}
                      </TableCell>
                      <TableCell align="right">{row.fee}</TableCell>
                      <TableCell align="right">{row.visaExpiry}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContentText>
        </DialogContent>
        <hr />
      </Dialog>
    </div>
  );
}
